import { render, staticRenderFns } from "./ConsumerSpaceLayout.vue?vue&type=template&id=78df210a&scoped=true"
import script from "./ConsumerSpaceLayout.vue?vue&type=script&lang=js"
export * from "./ConsumerSpaceLayout.vue?vue&type=script&lang=js"
import style0 from "./ConsumerSpaceLayout.vue?vue&type=style&index=0&id=78df210a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78df210a",
  null
  
)

export default component.exports